import { BaseDTO } from "./BaseDTO";

export class TipoIvaGestionDTO extends BaseDTO {
    codigo?: number;
    porcentajeIva?: number;
    porcentajeRecargo?: number;
    exento?: number;
}